// components/CustomScriptInjector/google.ts — auto-convert bare tracking ID to full snippet
const GA4_ID_RE = /^G-[A-Z0-9]{4,20}$/i;
const UA_ID_RE = /^UA-\d{4,10}-\d{1,4}$/i;
const AW_ID_RE = /^AW-\d{8,12}$/i;
const GTM_ID_RE = /^GTM-[A-Z0-9]{4,10}$/i;

const gtagSnippet = (id: string): string =>
    `<script async src="https://www.googletagmanager.com/gtag/js?id=${id}"></script>\n` +
    `<script>\n` +
    `window.dataLayer = window.dataLayer || [];\n` +
    `function gtag(){dataLayer.push(arguments);}\n` +
    `gtag('js', new Date());\n` +
    `gtag('config', '${id}');\n` +
    `</script>`;

const gtmSnippet = (id: string): string =>
    `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');</script>`;

export function normalizeGoogleScript(content: string): string {
    const trimmed = content.trim();
    if (GA4_ID_RE.test(trimmed) || UA_ID_RE.test(trimmed) || AW_ID_RE.test(trimmed)) {
        return gtagSnippet(trimmed.toUpperCase());
    }
    if (GTM_ID_RE.test(trimmed)) {
        return gtmSnippet(trimmed.toUpperCase());
    }
    return content;
}
